import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useAmbassadorProgramEnabled } from "@/hooks/useAmbassadorProgramEnabled";
import { UpPromoteJoinPage } from "@/components/ambassador/UpPromoteJoinPage";

// صفحات تابعة لتسجيل UpPromote تعمل بغضّ النظر عن البرنامج المحلّيّ.
const UPPROMOTE_PATHS = ["/ambassadors/joined", "/ambassadors/join-terms"];

function AmbassadorsLayout() {
  const on = useAmbassadorProgramEnabled();
  const { pathname } = useLocation();
  if (on || UPPROMOTE_PATHS.some((p) => pathname.startsWith(p))) return <Outlet />;
  // البرنامج المحلّيّ متوقّف: التسجيل يتمّ عبر UpPromote دون مغادرة الموقع.
  return <UpPromoteJoinPage />;
}

export const Route = createFileRoute("/ambassadors")({
  component: AmbassadorsLayout,
});
